export default "__VITE_ASSET__CZu1B25A__"